import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "main-page" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center main-wallet__header" }
const _hoisted_3 = { class: "main-wallet__title" }
const _hoisted_4 = { class: "main-wallet__percents-list d-flex justify-content-end align-items-end" }
const _hoisted_5 = { class: "main-wallet__percents-item text-capitalize-first" }
const _hoisted_6 = { class: "main-wallet__percents-item text-capitalize-first" }
const _hoisted_7 = { class: "main-wallet__top main-wallet__top__store" }
const _hoisted_8 = { class: "main-wallet__main-info" }
const _hoisted_9 = { class: "main-wallet__icon_small" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "main-wallet__info" }
const _hoisted_12 = { class: "main-wallet__sum main-wallet__sum__small" }
const _hoisted_13 = { class: "main-wallet__number-title text-capitalize-first" }
const _hoisted_14 = {
  key: 0,
  class: "main-wallet__wallet"
}
const _hoisted_15 = { class: "main-wallet__wallet-address for-copy" }
const _hoisted_16 = { class: "main-wallet__controls" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "text-capitalize-first" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_LoaderContent = _resolveComponent("LoaderContent")!
  const _component_AccountOperationPopup = _resolveComponent("AccountOperationPopup")!
  const _component_WithdrawalPopup = _resolveComponent("WithdrawalPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LoaderContent, { ref: "loader" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stores, (store) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "main-wallet",
              key: store.id
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(store.name) + " (" + _toDisplayString(store.currency) + ") ", 1),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.helper.trans(`direction.in`)) + ":", 1),
                      _cache[0] || (_cache[0] = _createTextVNode()),
                      _createElementVNode("span", null, _toDisplayString(_ctx.numberFormatter.formatNumber(store.payInFee * 100, 2)) + "%", 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.helper.trans(`direction.out`)) + ":", 1),
                      _cache[1] || (_cache[1] = _createTextVNode()),
                      _createElementVNode("span", null, _toDisplayString(_ctx.numberFormatter.formatNumber(store.payOutFee * 100, 2)) + "%", 1)
                    ])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(store.accounts, (msAccount) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("img", {
                          src: _ctx.helper.currencyIcon(msAccount.account.currency)
                        }, null, 8, _hoisted_10)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.numberFormatter.formatNumber(msAccount.account.sumWithoutInsurance)), 1),
                          _createTextVNode(" " + _toDisplayString(msAccount.account.currency), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('dashboard.on_hold')) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(msAccount.account.frozenSum)) + " " + _toDisplayString(msAccount.account.sum.currency), 1),
                        (msAccount.account._wallet)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createElementVNode("span", _hoisted_15, _toDisplayString(msAccount.account._wallet ? _ctx.truncateAddress(msAccount.account._wallet.address) : ''), 1),
                              _cache[2] || (_cache[2] = _createElementVNode("span", null, "(USDT TRC20)", -1)),
                              _createVNode(_component_CopyButton, {
                                value: msAccount.account._wallet?.address
                              }, null, 8, ["value"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      (_ctx.isMerchant)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "#",
                            onClick: _withModifiers(($event: any) => (_ctx.showWithdrawal(msAccount.account)), ["prevent"]),
                            class: "btn main-wallet__btn"
                          }, [
                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('button.withdraw')), 1)
                          ], 8, _hoisted_17))
                        : _createCommentVNode("", true),
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _withModifiers(($event: any) => (_ctx.showHistory(msAccount.account)), ["prevent"]),
                        class: "btn main-wallet__btn"
                      }, [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('button.history')), 1)
                      ], 8, _hoisted_19)
                    ])
                  ]))
                }), 256))
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_AccountOperationPopup, { ref: "accountOperationPopup" }, null, 512),
    _createVNode(_component_WithdrawalPopup, { ref: "withdrawalPopup" }, null, 512)
  ], 64))
}